import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { format } from 'date-fns';
import { useNavigate } from 'react-router';

const PaymentDoneModal = props => {
  const [endDate, setEndDate] = useState<any>('');
  const navigate = useNavigate();
  const getStep: any = localStorage.getItem('step');

  useEffect(() => {
    if (props?.planView?.endDate) {
      const date = new Date(props?.planView?.endDate);
      setEndDate(format(date, 'dd MMMM yyyy') || '');
    }
  }, [props?.planView?.endDate]);

  const handleDashboard = () => {
    const isFreePlan = props?.planView?.name === 'Free Access' || props?.planView?.name === 'Free';
    if (getStep == 2 && !isFreePlan) {
      navigate('/evidence');
    } else if (getStep == 2 && isFreePlan) {
      navigate('/step-2');
    } else {
      navigate('/');
    }
  };

  return (
    <Modal isOpen={props?.isPaymentDone} centered className="payment-done">
      <ModalHeader
        toggle={() => {
          props?.handleCloseModal();
        }}
      ></ModalHeader>

      <ModalBody className="text-center px-4 pb-5 pt-0">
        <div className="d-flex justify-content-center mb-3">
          <div
            style={{
              width: '86px',
              height: '86px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src="content/images/cases/done.png" alt="profile img" />
          </div>
        </div>

        {/* Title */}
        <h4 className="fw-bold">Payment Successful!</h4>
        <p className="text-muted mb-1">Your plan is now active 🎉</p>
        <p className="text-muted w-75 mx-auto" style={{ fontSize: '14px' }}>
          Your subscription has been successfully activated and will renew on <strong>{endDate}</strong>. You can manage your subscription
          anytime from your account settings.
        </p>

        {/* Buttons */}
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button className="download-button" onClick={() => handleDashboard()}>
            Go to Dashboard
          </Button>
          <Button className="plans" onClick={() => props?.handleCloseModal()}>
            Manage Plans
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PaymentDoneModal;
